import React from 'react';
import {Route, Routes} from 'react-router';
import {AccountType} from '../../components/constants/securspace-constants';
import HubspotBuyerSignup from '../../views/HubspotBuyerSignup';

const ExternalContent: React.FC = () => {
  return (
    <Routes>
      <Route
        path="/external-buyer-signup"
        element={<HubspotBuyerSignup type={AccountType.BUYER}/>}
      />
    </Routes>
  );
};

export default ExternalContent;
